// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:992px){.the-personal-skeleton-order{padding-top:20px}}.the-personal-skeleton-order__item{height:160px;margin-bottom:10px;background-color:#e5e5ec;border-radius:7px}@media only screen and (min-width:992px){.the-personal-skeleton-order__item{margin:0 30px 10px;height:40px}}", ""]);
// Exports
module.exports = exports;
